module.exports = __webpack_public_path__ + "img/recruit-icon-1.24f517db.png";